<div class="lt-filter-dialog-header" mat-dialog-title>
    <span>Filter Data</span>
    <button matIconButton (click)="close()" [attr.aria-label]="'Close dialog'">
    <mat-icon>close</mat-icon>
    </button>
</div>

<mat-dialog-content class="lt-filter-dialog-content">
    <app-lt-filter
        [columns]="dialogData.columns"
        [filter]="dialogData.filter"
        (apply)="applyFilter($event)"
        (filterCancel)="close()">
    </app-lt-filter>
</mat-dialog-content>